import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getPowerGenerationMaintenanceList as getPowerGenerationMaintenanceListApi,
	getPowerGenerationMaintenance as getPowerGenerationMaintenanceApi,
	addNewPowerGenerationMaintenance as addNewPowerGenerationMaintenanceApi,
	updatePowerGenerationMaintenance as updatePowerGenerationMaintenanceApi,
	deletePowerGenerationMaintenance as deletePowerGenerationMaintenanceApi,
} from '../../helpers/establishment/backend_helper';

export const getPowerGenerationMaintenanceList = createAsyncThunk('powerGenerationMaintenance/getPowerGenerationMaintenanceList', async (params) => {
	try {
		const response = getPowerGenerationMaintenanceListApi(params);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getPowerGenerationMaintenance = createAsyncThunk('powerGenerationMaintenance/getPowerGenerationMaintenance', async powerGenerationMaintenance_id => {
	try {
		const response = getPowerGenerationMaintenanceApi(powerGenerationMaintenance_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewPowerGenerationMaintenance = createAsyncThunk('powerGenerationMaintenance/addNewPowerGenerationMaintenance', async powerGenerationMaintenance => {
	try {
		const response = addNewPowerGenerationMaintenanceApi(powerGenerationMaintenance);
		toast.success('Mantención agregado exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al agregar powerGenerationMaintenance.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updatePowerGenerationMaintenance = createAsyncThunk('powerGenerationMaintenance/updatePowerGenerationMaintenance', async (powerGenerationMaintenance) => {
		try {
			const response = updatePowerGenerationMaintenanceApi(powerGenerationMaintenance);
			toast.success('Mantención actualizado exitosamente', { autoClose: 3000 });
			return response;
		} catch (error) {
			toast.error('Error al actualizar powerGenerationMaintenance.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deletePowerGenerationMaintenance = createAsyncThunk('powerGenerationMaintenance/deletePowerGenerationMaintenance', async powerGenerationMaintenance => {
	try {
		const response = await deletePowerGenerationMaintenanceApi(powerGenerationMaintenance);
		toast.success('Mantención eliminado exitosamente.', { autoClose: 3000 });
		return { powerGenerationMaintenance, ...response };
	} catch (error) {
		toast.error('Error al eliminar powerGenerationMaintenance.', { autoClose: 3000 });
		throw new Error(error);
	}
});


